import { Link, Outlet, useLocation } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { Header } from "../ui/Header";
import { usePortalAuth } from "../../hooks/usePortalAuth";

/**
 * Coquille des routes protégées du portail.
 *
 * W7-B — le retour au tableau de bord vit ICI, une fois. Les onze pages
 * portaient chacune leur `min-h-screen bg-cream` — un plein-écran de plus à
 * l'intérieur de celui de `AppRouter` — et leur propre lien « Retour » : dix
 * copies du même geste, à dix hauteurs différentes selon la page. Le fond et la
 * hauteur de page appartiennent à la racine de l'application, une seule fois.
 * Le `<main>` reste aux pages — il ne doit y en avoir qu'un par écran.
 *
 * Le retour disparaît pendant un changement de mot de passe FORCÉ : le reste du
 * portail est fermé côté API tant que le mot de passe n'est pas changé, un lien
 * vers le tableau de bord ne mènerait qu'à un refus.
 */
export function PortalShell() {
  const { mustChangePassword } = usePortalAuth();
  const { pathname, search } = useLocation();

  const onChangePasswordScreen =
    pathname === "/profile" && new URLSearchParams(search).get("changePassword") === "1";
  const locked = mustChangePassword || onChangePasswordScreen;

  return (
    <div data-testid="portal-shell">
      <Header />
      {!locked && pathname !== "/dashboard" && (
        <div className="mx-auto max-w-5xl px-4 pt-4">
          <Link
            to="/dashboard"
            className="inline-flex items-center gap-1 text-sm text-muted hover:text-terracotta"
          >
            <ArrowLeft size={16} aria-hidden /> Tableau de bord
          </Link>
        </div>
      )}
      <Outlet />
    </div>
  );
}
